// extracted by mini-css-extract-plugin
export default {"modal":"search-modal_modal__yFg7-","shown":"search-modal_shown__4mbXq"};